import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=36ab5b7a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36ab5b7a')) {
      api.createRecord('36ab5b7a', component.options)
    } else {
      api.reload('36ab5b7a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=36ab5b7a&", function () {
      api.rerender('36ab5b7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2i0xIzz3NwcEw/JS/cancellationPolicy.vue"
export default component.exports